module.exports = __webpack_public_path__ + "static/media/background.40a07869.webp";